import useDatasetDocumentation from 'hooks/data/datasets/documentation/useDatasetDocumentation';
import useAllIndicators from 'hooks/data/datasets/lcia/useAllIndicators';
import useLciaScores from 'hooks/data/datasets/lcia/useLciaScores';
import { buildDefaultSelectedLciaMethod } from 'pages/Search/components/SearchPreferencesModalContent/utils';

import { toReleaseRef } from './datasetRef';
import { CompareDataset } from './types';

// Search results are the only source that sends the score and time period, so datasets staged elsewhere fetch them.
export const useCompareDatasetDetails = (dataset: CompareDataset): CompareDataset => {
  const release = toReleaseRef(dataset);
  const needsScore = typeof dataset.impactScore !== 'number';

  const { data: indicators } = useAllIndicators(release);
  const indicatorId =
    needsScore && indicators
      ? buildDefaultSelectedLciaMethod(indicators, release.version, release.system_model).methodId
      : undefined;
  const { data: scores } = useLciaScores(Number(dataset.id), indicatorId, release);
  const score = scores?.find((lciaScore) => lciaScore.index === indicatorId);

  const { data: documentation } = useDatasetDocumentation(dataset.timePeriod ? undefined : dataset.id, release);

  return {
    ...dataset,
    impactScore: dataset.impactScore ?? score?.amount,
    impactUnit: dataset.impactUnit ?? score?.unit_name,
    timePeriod: dataset.timePeriod ?? documentation?.activity_description?.time_period,
  };
};
